import { render, staticRenderFns } from "./BaoCaoNhanPhong.vue?vue&type=template&id=769994de&"
import script from "./BaoCaoNhanPhong.vue?vue&type=script&lang=js&"
export * from "./BaoCaoNhanPhong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports